const namespaced = true
import api from '../../../../api/sap/invoice/customer_sap.js';
import _ from 'lodash';
import { downloadFile } from '../../../../src/helpers/util.js'

const state = {
    loading: false,
    invoicesServicesCustomerSapFlag: false,
    invoicesServicesCustomerSapExpand: false,
    invoices_customer_sap: [],
    invoices_services_customer_sap: [],
    invoices_services_customer_sap_original: [],
    warehouses_selected_by_invoices_services_customer_sap: { WhsCode: '*', WhsName: 'Todos' },
    selectDocNumInvoiceService: null,
    invoice_customer: null,
    invoices_customer_sap_dashboard: [],
}

const mutations = {
    SET_LOADING(state, val) {
        state.loading = val;
    },
    MUTATION_SET_INVOICE_CUSTOMER_SAP(state, data) {
        state.invoices_customer_sap = data;
    },
    MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP(state, data) {
        let array = [];
        _.forEach(data.data, function (value) {
            let tempo = value;
            tempo.whsObject = _.find(data.root.warehouses_sap.warehouses_sap, { 'WhsCode': tempo.WhsCode })
            array.push(tempo)
        });
        state.invoices_services_customer_sap = array;
        state.invoices_services_customer_sap_original = array;
    },
    MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_FLAG(state, value) {
        state.invoicesServicesCustomerSapFlag = value;
    },
    MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_EXPAND(state, value) {
        state.invoicesServicesCustomerSapExpand = value;
    },
    MUTATION_SET_WAREHOUSES_SELECT_BY_INVOICE_SERVICES_CUSTOMER_SAP(state, data) {
        state.warehouses_selected_by_invoices_services_customer_sap = data;
    },
    MUTATION_SET_FILTER(state) {
        state.invoices_services_customer_sap = state.invoices_services_customer_sap_original;
        state.invoices_services_customer_sap = (state.warehouses_selected_by_invoices_services_customer_sap.WhsCode == '*') ? state.invoices_services_customer_sap : _.filter(state.invoices_services_customer_sap, { 'WhsCode': state.warehouses_selected_by_invoices_services_customer_sap.WhsCode });
    },
    MUTATION_SET_SELECT_DOC_NUM_INVOICE_SERVICES(state, value) {
        state.selectDocNumInvoiceService = value;
    },
    MUTATION_SET_INVOICE_SERVICES_CUSTOMER_CLEAR(state, value) {
        state.invoices_services_customer_sap = value;
        state.invoices_services_customer_sap_original = value;
    },
    MUTATION_SET_INVOICE_CUSTOMER(state, data) {
        state.invoice_customer = data;
    },
    MUTATION_SET_INVOICE_CUSTOMER_SAP_DASHBOARD(state, data) {
        state.invoices_customer_sap_dashboard = data;
    },

}
const actions = {
    getInvoicesCustomer(context, data) {
        api.getInvoicesCustomer(data.date1, data.date2).then(function (res) {
            context.commit('MUTATION_SET_INVOICE_CUSTOMER_SAP', res.data);
        }).catch((e) => {
            context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
        })
    },
    getInvoicesServices({ commit, dispatch, rootState }, data) {
        commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_FLAG', true);
        api.getInvoicesServices(data.date1, data.date2).then(function (res) {
            commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP', { data: res.data, root: rootState });
            dispatch('filters');
            commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_FLAG', false);
        }).catch((e) => {
            commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_CLEAR', []);
            commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_FLAG', false);
            dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
        })
    },
    setServicesCustomerSapFlag(context, value) {
        context.commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_FLAG', value);
    },
    setServicesCustomerSapExpand(context, value) {
        context.commit('MUTATION_SET_INVOICE_SERVICES_CUSTOMER_SAP_EXPAND', value);
    },
    setSelectDocNumInvoiceServices(context, value) {
        context.commit('MUTATION_SET_SELECT_DOC_NUM_INVOICE_SERVICES', value);
    },
    setWarehouseSelectServicesCustomerSap(context, value) {
        context.commit('MUTATION_SET_WAREHOUSES_SELECT_BY_INVOICE_SERVICES_CUSTOMER_SAP', value);
        context.dispatch('filters');
    },
    filters(context) {
        context.commit('MUTATION_SET_FILTER');
    },
    getInvoice(context, data) {
        return new Promise((resolve) => {
            api.getInvoice(data).then(function (res) {
                context.commit('MUTATION_SET_INVOICE_CUSTOMER', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })

    },
    getSales(context, data) {
        return new Promise((resolve) => {
            context.commit('SET_LOADING', true);
            api.getSales(data.date1, data.date2).then(function (res) {
                context.commit('MUTATION_SET_INVOICE_CUSTOMER_SAP_DASHBOARD', res.data);
                context.commit('SET_LOADING', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })

    },
    getSalesExport(context, data) {
        return new Promise((resolve) => {
            context.commit('SET_LOADING', true);
            api.getSalesExport(data).then(function (res) {
                downloadFile(res.data, 'analisis de ventas.xlsx');
                context.commit('SET_LOADING', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })

    },
}

const getters = {
    getWarehouses: (state, getter, rootState) => {
        return _.uniq(state.invoices_services_customer_sap_original.map(item =>
            _.find(rootState.warehouses_sap.warehouses_sap, { 'WhsCode': item.WhsCode })
        ));
    },
    getItemsServices(state) {
        let Services = _.find(state.invoices_services_customer_sap, { 'DocNum': state.selectDocNumInvoiceService });
        return (Services)?Services.Lines:[];
    },
    getDataTable(state) {
        const bannerInvoice = _.has(state.invoices_customer_sap_dashboard, 'invoices');
        const bannerInvoiceCancelations = _.has(state.invoices_customer_sap_dashboard, 'invoiceCancelations');
        if (bannerInvoice && bannerInvoiceCancelations)
            return _.concat(state.invoices_customer_sap_dashboard.invoices, state.invoices_customer_sap_dashboard.invoiceCancelations);
        else
            return [];
    },
    getDataTableExport(state, getter) {
        let transformData = _.map(getter.getDataTable, item => [
            item.CardName,
            item.DocDate,
            item.DocNum,
            item.ItmsGrpCod,
            item.ItmsGrpNam,
            item.DocTotal,
            item.TipoDocumento,
            item.Weight,
            item.WTSum,
            item.VatSum,
            item.CANCELED,
        ]);
        return transformData;
    },
    getTotalArena(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '108'; }), 'Weight');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '108'; }), 'Weight');
        return (sumInvoice - sumInvoiceCancelations) / 1000;
    },
    getTotalMontoArena(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '108'; }), 'DocTotal');
        let sumInvoiceTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '108'; }), 'VatSum');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '108'; }), 'DocTotal');
        let sumInvoiceCancelationsTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '108'; }), 'VatSum');

        return ((sumInvoice - sumInvoiceTax) - (sumInvoiceCancelations - sumInvoiceCancelationsTax));
    },

    getTotalTonFertilizante(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '102'; }), 'Weight');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '102'; }), 'Weight');
        return (sumInvoice - sumInvoiceCancelations) / 1000;
    },
    getTotalMontoFertilizante(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '102'; }), 'DocTotal');
        let sumInvoiceTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '102'; }), 'VatSum');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '102'; }), 'DocTotal');
        let sumInvoiceCancelationsTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '102'; }), 'VatSum');

        return ((sumInvoice - sumInvoiceTax) - (sumInvoiceCancelations - sumInvoiceCancelationsTax));
    },

    getTotalTonFosfatos(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '103'; }), 'Weight');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '103'; }), 'Weight');
        return (sumInvoice - sumInvoiceCancelations) / 1000;
    },
    getTotalMontoFosfatos(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '103'; }), 'DocTotal');
        let sumInvoiceTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '103'; }), 'VatSum');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '103'; }), 'DocTotal');
        let sumInvoiceCancelationsTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '103'; }), 'VatSum');

        return ((sumInvoice - sumInvoiceTax) - (sumInvoiceCancelations - sumInvoiceCancelationsTax));
    },

    getTotalTonMinerales(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '109'; }), 'Weight');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '109'; }), 'Weight');
        
        let sumInvoicesSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '106'; }), 'Weight');
        let sumInvoiceCancelationsSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '106'; }), 'Weight');

        return ((sumInvoice - sumInvoiceCancelations) + (sumInvoicesSM - sumInvoiceCancelationsSM)) / 1000;
    },
    getTotalMontoMinerales(state) {

        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '109'; }), 'DocTotal');
        let sumInvoiceTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '109'; }), 'VatSum');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '109'; }), 'DocTotal');
        let sumInvoiceCancelationsTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '109'; }), 'VatSum');

        let sumInvoiceSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '106'; }), 'DocTotal');
        let sumInvoiceTaxSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '106'; }), 'VatSum');
        let sumInvoiceCancelationsSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '106'; }), 'DocTotal');
        let sumInvoiceCancelationsTaxSM = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '106'; }), 'VatSum');

        return ((sumInvoice - sumInvoiceTax) - (sumInvoiceCancelations - sumInvoiceCancelationsTax)) + ((sumInvoiceSM - sumInvoiceTaxSM) - (sumInvoiceCancelationsSM - sumInvoiceCancelationsTaxSM));
    },

    getTotalTonPremezclas(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '104'; }), 'Weight');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '104'; }), 'Weight');
        return (sumInvoice - sumInvoiceCancelations) / 1000;
    },
    getTotalMontoPremezclas(state) {
        let sumInvoice = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '104'; }), 'DocTotal');
        let sumInvoiceTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoices, function (o) { return o.ItmsGrpCod == '104'; }), 'VatSum');
        let sumInvoiceCancelations = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '104'; }), 'DocTotal');
        let sumInvoiceCancelationsTax = _.sumBy(_.filter(state.invoices_customer_sap_dashboard.invoiceCancelations, function (o) { return o.ItmsGrpCod == '104'; }), 'VatSum');

        return ((sumInvoice - sumInvoiceTax) - (sumInvoiceCancelations - sumInvoiceCancelationsTax));
    }
 
}
export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}